import React from 'react';
import MultiRoleCell from './MultiRoleCell';
import { ScheduleItem, ScheduleItemContract } from '@app-types';
import { UserPermissions } from '@contexts/AuthContext';

const ContractOwnerCell: React.FC<{
  scheduleItem: ScheduleItem;
  contract: ScheduleItemContract;
  isGroupRow: boolean;
  isChildRow: boolean;
  permissions: UserPermissions;
  onAssignRole: (
    item: ScheduleItem,
    contractId: number,
    role: 'owner' | 'manager' | 'assessor',
    isGroupOperation?: boolean
  ) => void;
}> = ({ scheduleItem, contract, isGroupRow, isChildRow, permissions, onAssignRole }) => {
  // For parent row in a bundle, show all unique owners from all contracts
  let displayOwners = contract.contract_owners;
  if (isGroupRow && !isChildRow) {
    const allOwners = scheduleItem.contracts.flatMap((c) => c.contract_owners);
    const uniqueOwners = Array.from(new Map(allOwners.map((o) => [o.id, o])).values());
    displayOwners = uniqueOwners;
  }

  return (
    <MultiRoleCell
      assignees={displayOwners}
      roleType="owner"
      scheduleItem={scheduleItem}
      contractId={contract.id}
      permissions={permissions}
      onAssignRole={onAssignRole}
      isChildRow={isChildRow}
      isGroupRow={isGroupRow}
    />
  );
};

export default ContractOwnerCell;
